import type { CSSObject } from '@emotion/react'
import { css } from '@emotion/react'
import {
  Typography,
  Spacing,
  Theme,
  Color,
  Size,
  CornerRadius,
  ThemedColors,
  gemVar,
} from '@opallabs/gem'
import { modernWithFallback } from '@opallabs/lambda'

export const modal = css({
  inlineSize: 580,
  ...modernWithFallback(
    [
      { overflowBlock: 'visible', overflowInline: 'hidden' },
      { overflowY: 'visible', overflowX: 'hidden' },
    ],
    'overflowBlock: auto'
  ),

  '[data-hideform="true"]': {
    display: 'none',
  },
})

export const loaderContainer = css({
  alignItems: 'center',
  display: 'flex',
  inlineSize: '100%',
})

export const resourceTitleContainer = (theme: Theme) =>
  css({
    backgroundColor: Color[theme].Surface.N100,
    border: `solid 1px ${Color[theme].Surface.N200}`,
    borderRadius: Size.Rounding * 2,
    columnGap: Spacing.S,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    paddingInline: '12px',
    marginBlockEnd: '24px',
    minBlockSize: '48px',
  })

export const resourceTitle = (theme: Theme) =>
  css({
    ...Typography.T500,
    color: Color[theme].Text.Default,
    overflow: 'hidden',
    position: 'relative',
    textOverflow: 'ellipsis',
    insetBlockStart: 1,
    whiteSpace: 'nowrap',
    margin: 0,
  })

export const privacySelect = css({
  inlineSize: '100%',
  marginBlock: Spacing.L,

  button: {
    // Fixes strange issue that forces a scrollbar because the trigger's (`<Button>`)'s `::before` has an `inset` of
    // -1px, which by default would be based on `privacySelect`'s `width: 100%`, since that's the closest ancestor with
    // `position` set, making this 2px too wide.
    position: 'relative',
  },
})

// can't use css function here yet because StyleOverrides
//  type only accepts CSSObject type
export const label: CSSObject = {
  marginBlockEnd: Spacing.XS,
}

// can't use css function here yet because StyleOverrides
//  type only accepts CSSObject type
export const buttonOverrides: CSSObject = {
  inlineSize: 104,
}

export const footerOverrides = css({
  justifyContent: 'space-between',
})

export const permissionListWrapper = css({
  position: 'relative',
})

export const permissionSummary = css({
  alignItems: 'start',
  background: gemVar(ThemedColors.Primary2),
  border: `1px solid ${gemVar(ThemedColors.StrokePrimary1)}`,
  borderRadius: CornerRadius.Large,
  marginBlockStart: Spacing.L,
  padding: Spacing.XS * 3,

  'h3, p': {
    color: gemVar(ThemedColors.TextLinks),
  },
})
